import ActivityFeed from "./ActivityFeed";

/** Activity tab — the job's activity log. */
export default function ProjectSettingsTab({ project }) {
  return (
    <div className="space-y-5" data-testid="ops-project-activity-tab">
      <ActivityFeed projectId={project.id} />
    </div>
  );
}
